<pa-checkbox-tree ngDefaultControl [formControl]="control"
    [checkboxes]="checkboxes" (selection)="onSelection($event)">{{ schema.title }}</pa-checkbox-tree>
